import React from 'react';
import TaskBoardContent from './TaskBoard/TaskBoardContent';

export default function DailyTask() {
  return <TaskBoardContent />;
}

